// src/Pages/Stripe/StripeSuccess/index.tsx

import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useT } from "../../../i18n";

export const StripeSuccess = () => {
  const t = useT();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown === 0) {
      navigate("/establishment/subscription");
      return;
    }
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown, navigate]);

  return (
    <div style={{
      minHeight: "100vh", background: "#f5f5f5",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "#fff", borderRadius: 18, padding: "48px 40px",
        maxWidth: 440, width: "100%", textAlign: "center",
        boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
      }}>
        {/* Check icon */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            background: "#e6f7ef", display: "flex",
            alignItems: "center", justifyContent: "center",
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="#1a7a4a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#111", margin: "0 0 10px" }}>
          {t("Assinatura confirmada!")}
        </h1>
        <p style={{ fontSize: 14, color: "#888", margin: "0 0 28px", lineHeight: 1.6 }}>
          {t("Seu pagamento foi processado com sucesso.")}<br />
          {t("Sua assinatura já está ativa na plataforma Pertalks.")}
        </p>

        {sessionId && (
          <p style={{ fontSize: 11, color: "#ccc", margin: "0 0 20px", wordBreak: "break-all" }}>
            {t("ID da sessão: {id}", { id: sessionId })}
          </p>
        )}

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, color: "#888", fontSize: 13 }}>
          <CircularProgress size={14} style={{ color: "#00b6bc" }} />
          {t("Redirecionando em {segundos}s…", { segundos: countdown })}
        </div>

        <button
          onClick={() => navigate("/establishment/subscription")}
          style={{
            marginTop: 20, padding: "11px 28px", background: "#00b6bc",
            color: "#fff", border: "none", borderRadius: 10,
            fontWeight: 700, fontSize: 14, cursor: "pointer", width: "100%",
          }}
        >
          {t("Ver minha assinatura")}
        </button>
      </div>
    </div>
  );
};